import AccessCodesExporter from './access_codes_exporter'
import AccreditationStatusesExporter from './accreditation_statuses_exporter'
import BusinessTxCSVExporter from './business_tx_csv_exporter'
import InsightsExporter from './insights_exporter'
import UserTxCSVExporter from './user_tx_csv_exporter'

export default class CSVExporterFactory {
  static USER = 1
  static BUSINESS = 2
  static INSIGHTS = 3
  static ACCESS_CODES = 4
  static ACCREDITATION_STATUSES = 5

  constructor() {
    throw new Error('instantiation prohibited')
  }

  /**
   * factory method to create exporter
   * @param type
   * @param data
   * @param header
   * @return BaseExporter
   */
  static create(type, data = [], header = []) {
    switch (type) {
      case CSVExporterFactory.USER:
        return new UserTxCSVExporter(data, header)
      case CSVExporterFactory.BUSINESS:
        return new BusinessTxCSVExporter(data, header)
      case CSVExporterFactory.INSIGHTS:
        return new InsightsExporter(data, header)
      case CSVExporterFactory.ACCESS_CODES:
        return new AccessCodesExporter(data, header)
      case CSVExporterFactory.ACCREDITATION_STATUSES:
        return new AccreditationStatusesExporter(data, header)
      default:
        throw new Error('Uknown type supplied for CSV exporter factory: ' + type)
    }
  }
}
